import React, { useState } from "react";

import ContentHeader from "components/Layout/ContentHeader";
import Badge from "components/UI/Badge";
import Button from "components/UI/Button";
import { Input } from "components/UI/Input";
import Modal from "components/UI/Modal";
import Table, { Column } from "components/UI/Table";
import "pages/AdminPage.scss";

interface Tag {
  id: string;
  name: string;
  nameEn: string;
  productCount: number;
  isVisible: boolean;
}

const MOCK: Tag[] = [
  { id: "1", name: "인기", nameEn: "Popular", productCount: 45, isVisible: true },
  { id: "2", name: "신상", nameEn: "New", productCount: 32, isVisible: true },
  { id: "3", name: "할인", nameEn: "Sale", productCount: 28, isVisible: true },
  { id: "4", name: "추천", nameEn: "Recommend", productCount: 56, isVisible: true },
  { id: "5", name: "친환경", nameEn: "Eco", productCount: 14, isVisible: true },
  { id: "6", name: "한정판", nameEn: "Limited", productCount: 8, isVisible: false },
  { id: "7", name: "패키지", nameEn: "Package", productCount: 22, isVisible: true },
  { id: "8", name: "방문예약", nameEn: "Reservation", productCount: 17, isVisible: true },
];

const ProductTagSetting: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: "", nameEn: "" });

  const columns: Column<Tag>[] = [
    { key: "name", title: "태그명 (KR)" },
    { key: "nameEn", title: "태그명 (EN)", width: "160px" },
    { key: "productCount", title: "사용 상품 수", width: "110px", render: (v) => `${v}개` },
    {
      key: "isVisible",
      title: "공개여부",
      width: "90px",
      render: (v) => <Badge variant={v ? "active" : "draft"}>{v ? "공개" : "숨김"}</Badge>,
    },
    {
      key: "actions",
      title: "관리",
      width: "130px",
      render: () => (
        <div style={{ display: "flex", gap: 6 }}>
          <Button size="sm" variant="ghost">
            수정
          </Button>
          <Button size="sm" variant="ghost">
            삭제
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="admin-page">
      <ContentHeader
        title="상품 태그 설정"
        description="상품에 적용할 태그를 관리합니다."
        actions={[
          <Button key="add" variant="primary" onClick={() => setShowModal(true)}>
            + 태그 추가
          </Button>,
        ]}
      />
      <div className="admin-page__card">
        <Table columns={columns} data={MOCK} rowKey="id" />
      </div>
      <Modal
        open={showModal}
        title="태그 추가"
        onClose={() => setShowModal(false)}
        width="400px"
        footer={
          <>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              취소
            </Button>
            <Button variant="primary" onClick={() => setShowModal(false)}>
              추가
            </Button>
          </>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Input label="태그명 (KR)" placeholder="예: 인기" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
          <Input label="태그명 (EN)" placeholder="예: Popular" value={form.nameEn} onChange={(e) => setForm((p) => ({ ...p, nameEn: e.target.value }))} />
        </div>
      </Modal>
    </div>
  );
};

export default ProductTagSetting;
